import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-cylinder",
  "use": "icon-th-cylinder-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-cylinder\">\n<path d=\"M16 2C10.9538 2 7 4.41625 7 7.5V24.5C7 27.5837 10.9538 30 16 30C21.0462 30 25 27.5837 25 24.5V7.5C25 4.41625 21.0462 2 16 2ZM16 4C19.3112 4 23 5.4375 23 7.5C23 9.5625 19.3112 11 16 11C12.6888 11 9 9.5625 9 7.5C9 5.4375 12.6888 4 16 4ZM16 28C12.2712 28 9 26.365 9 24.5V11C10.6375 12.2312 13.1425 13 16 13C18.8575 13 21.3625 12.225 23 11V24.5C23 26.365 19.7288 28 16 28Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-cylinder.svg
// module id = 6DQV
// module chunks = 83